import { cn, ui } from '../lib/ui';
import CopyButton from './CopyButton';

/**
 * The DNS records an address needs, each Name and Value with its own Copy
 * button so the org admin pastes exactly what the platform expects
 * (docs/Decisions.md D63 item 6). Shared by the setup wizard's domain step,
 * Org settings -> Custom domains and the site builder's site domains.
 */
export default function DnsRecordsTable({ records, showPurpose = false }) {
  if (!records || records.length === 0) return null;
  return (
    <div className={ui.tableWrap}>
      <table className={ui.table}>
        <caption className="sr-only">DNS records to publish</caption>
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Name</th>
            <th scope="col">Value</th>
            {showPurpose && <th scope="col">Purpose</th>}
          </tr>
        </thead>
        <tbody>
          {records.map((rec, i) => (
            <tr key={`${rec.type}-${rec.name}-${i}`}>
              <td className="align-top">
                <code className="font-mono text-caption">{rec.type}</code>
              </td>
              <td className="align-top">
                <div className="flex items-start gap-2">
                  <code className="font-mono text-caption break-all select-all">{rec.name}</code>
                  <CopyButton text={rec.name} label={`Copy the ${rec.type} record name`} />
                </div>
              </td>
              <td className="align-top">
                <div className="flex items-start gap-2">
                  <code className="font-mono text-caption break-all select-all">{rec.value}</code>
                  <CopyButton text={rec.value} label={`Copy the ${rec.type} record value`} />
                </div>
                {rec.note ? <p className={cn(ui.hint, 'font-sans')}>{rec.note}</p> : null}
              </td>
              {showPurpose && <td className="align-top">{rec.purpose}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
